import apiConfig from 'src/integration/config/apiConfig';
import { useStore } from 'src/integration/store/store';
import useQueryKey from 'src/toolkit/utils/useQueryKey';
import { useState } from 'react';
import routerPaths from 'src/integration/config/routerPaths';
import { useNavigate } from 'react-router-dom';
import useReactQueryJava from 'src/integration/api/useReactQueryJava';

const useFetchLogin = () => {
  const { configStore } = useStore();
  const { setJwtToken } = configStore;
  const [enabled, setEnabled] = useState(false);
  const navigate = useNavigate();
  const { removeJwtToken, email, password } = configStore;
  const [loginError, setLoginError] = useState<string | null>(null); // ✅ new

  const response = useReactQueryJava<SimpleObject, SimpleObject>({
    endpoint: apiConfig.api.endpointsJava.login,
    queryKey: useQueryKey('login', []),
    method: 'POST',
    body: {
      "email": email,
      "password": password
    },
    opts: {
      enabled: enabled,
      retry: 0,
      onSuccess: (data: SimpleObject) => {
        setJwtToken(data.token);
        setEnabled(false);
        navigate(routerPaths.home());
      },
      onError: (error: any) => {
        setEnabled(false);
        removeJwtToken();
        if  (error.status === 401) {
          return  setLoginError('Invalid email or password.');
        }
        return setLoginError('Something went wrong.');
      },
    },
  });

  const fetchLoginData = () => {
    setEnabled(true);
  };

  return {
    ...response,
    loginError,
    fetchLoginData
  };
};

export default useFetchLogin;
